import React, { useEffect, useState } from 'react';

import { getStudentProfileInfo } from '../../../../../services/apiService';

import { useLocation } from 'react-router-dom';

import BasicInfo from './_sections/BasicInfo';
import Education from './_sections/Education';
import Skills from './_sections/Skills';
import Social from './_sections/Social';
import UserSubscription from './_sections/UserSubscription';
import WorkExperience from './_sections/WorkExperience';

function Profile() {
  const location = useLocation();
  const userParams = location.state.userParams;

  const [profileInfo, setProfileInfo] = useState(null);

  const getProfileInfo = async (studentId) => {
    const response = await getStudentProfileInfo(studentId);
    setProfileInfo(response);
  };

  useEffect(() => {
    getProfileInfo(userParams?.id);
  }, []);

  return (
    <div className='flex flex-col gap-4'>
      {profileInfo && (
        <div className='flex flex-col gap-3'>
          <BasicInfo basicInfo={profileInfo.basicInfo} />
          <Education education={profileInfo.education} />
          <WorkExperience experience={profileInfo.workExperience} />
          <Social social={profileInfo.social} />
          <Skills skills={profileInfo.skills} />
          <UserSubscription
            userId={userParams?.id}
            courseType={userParams?.UserSubscriptions_courseType}
          />
        </div>
      )}
    </div>
  );
}

export default Profile;
